import React, { Component } from "react";

class Footer extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const social = this.props.data.social || [];
    const github = social.find((s) => s.name === "github");
    const linkedin = social.find((s) => s.name === "linkedin");
    const year = new Date().getFullYear();

    return (
      <footer className="w-full py-12 border-t border-outline-variant/20 bg-surface-container-lowest">
        <div className="max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="signature-logo text-3xl md:text-4xl text-primary">
            {name}
          </div>
          <p className="font-label-md text-label-md text-on-surface-variant">
            © {year} {name}. Forward Deployed Engineer · AI/ML.
          </p>
          <div className="flex gap-6">
            {linkedin && (
              <a
                className="text-on-surface-variant hover:text-primary transition-colors font-label-md text-label-md capitalize"
                href={linkedin.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            )}
            {github && (
              <a
                className="text-on-surface-variant hover:text-primary transition-colors font-label-md text-label-md capitalize"
                href={github.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
            )}
            {this.props.data.email && (
              <a
                className="text-on-surface-variant hover:text-primary transition-colors font-label-md text-label-md"
                href={`mailto:${this.props.data.email}`}
              >
                Email
              </a>
            )}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
